import { Pipe, PipeTransform } from '@angular/core';
import * as _ from "lodash"
@Pipe({
  name: 'search'
})
export class SearchPipe implements PipeTransform {

  transform(items: any[], field: string, value: string): any[] {
    console.log(items)
    if (value.length > 0) {

      let key = _.keysIn(items[0])
      let data = []
      let id=[]
      if (!items) {
        return items;
      }
      items.map(it => {
        for (let i = 0; i < key.length; i++) {
          if (typeof it[key[i]] == "string") {

            if (it[key[i]].toLowerCase().includes(value.toLowerCase())&&! id.includes(it._id)) {
              data.push(it)
              id.push(it._id)
            }
          }
        }

      });
      return data
    } else {
      return items;
    }
  }

}
